import { createRoot } from 'react-dom/client';
import { Root } from '~/app';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(<Root />);
